'use strict';

function overlappingService ($window, $q, $interval, constantSettings) {
			(function() {
					var gInterval = $interval(function(){
						if(typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
							 var s = $window.document.createElement('script');
							 s.src = 'components/oms/oms.min.js';
							 $window.document.body.appendChild(s);
							 $interval.cancel(gInterval);
						}
					}, constantSettings.fasterDelayTimeout);

			})();

			this.loadOverlapping = function() {
				return $q(function(resolve, reject) {
			    var overlappingStop = $interval(function() {
			      if((typeof OverlappingMarkerSpiderfier) != "undefined") {
							$interval.cancel(overlappingStop);
							resolve();
						};

			    }, constantSettings.fasterDelayTimeout);
			  });
			};
}
overlappingService.$inject = ['$window', '$q', '$interval', 'constantSettings']
export default overlappingService


// WEBPACK FOOTER //
// ./src/app/scripts/services/overlappingService.js